var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer", class: { mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "top" }, [
          _c(
            "div",
            { staticClass: "logo" },
            [
              _c(
                "router-link",
                {
                  class: {
                    "b-sprite-landing-brilliant-logo-white": !_vm.isMobile(
                      _vm.$mq
                    ),
                    "b-sprite-landing-brilliant-logo-white-small": _vm.isMobile(
                      _vm.$mq
                    )
                  },
                  attrs: { to: { name: "homepage" } }
                },
                [_vm._v("Brilliant")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "link-list company" }, [
            _c("h4", [_vm._v("Company")]),
            _vm._v(" "),
            _c("ul", { staticClass: "unstyled" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: { name: "about" } } }, [
                    _vm._v("About Us")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "learning_manifesto" } } },
                    [_vm._v("Principles")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "careers_page" } } },
                    [_vm._v("Careers")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "teacher_landing" } } },
                    [_vm._v("Educators")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "about", hash: "#for-the-press" } }
                    },
                    [_vm._v("Press")]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "link-list product" }, [
            _c("h4", [_vm._v("Product")]),
            _vm._v(" "),
            _c("ul", { staticClass: "unstyled" }, [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "explorations_menu" } } },
                    [_vm._v("Courses")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "daily_problems_listing" } } },
                    [_vm._v("Today")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { name: "payment_brilliant_square_plans" } }
                    },
                    [_vm._v("Pricing")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "testimonials" } } },
                    [_vm._v("Testimonials")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bottom" }, [
          _c("ul", { staticClass: "unstyled info-links" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "flatpage_faq" } } }, [
                  _vm._v("Help")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "flatpage_termsofuse" },
                      rel: "nofollow"
                    }
                  },
                  [_vm._v("Terms of Service")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "flatpage_privacypolicy" },
                      rel: "nofollow"
                    }
                  },
                  [_vm._v("Privacy Policy")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "flatpage_ccpa_policy" },
                      rel: "nofollow"
                    }
                  },
                  [
                    _vm.isNarrowScreen
                      ? [_vm._v("CPP")]
                      : [_vm._v("California Privacy Policy")]
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          © " +
                  _vm._s(new Date().getFullYear()) +
                  " Brilliant Worldwide, Inc., Brilliant and the\n          Brilliant Logo are trademarks of Brilliant Worldwide, Inc.\n        "
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "unstyled social" }, [
      _c("li", [
        _c(
          "a",
          {
            staticClass: "b-sprite-landing-facebook inline",
            attrs: {
              href: "https://www.facebook.com/brilliantorg",
              rel: "nofollow",
              target: "_blank"
            }
          },
          [_vm._v("Facebook")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "b-sprite-landing-instagram inline",
            attrs: {
              href: "https://www.instagram.com/brilliantorg",
              rel: "nofollow",
              target: "_blank"
            }
          },
          [_vm._v("Instagram")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "b-sprite-landing-twitter inline",
            attrs: {
              href: "https://twitter.com/brilliantorg",
              rel: "nofollow",
              target: "_blank"
            }
          },
          [_vm._v("Twitter")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "b-sprite-landing-linkedin inline",
            attrs: {
              href: "https://www.linkedin.com/company/brilliant-org/",
              rel: "nofollow",
              target: "_blank"
            }
          },
          [_vm._v("LinkedIn")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }